import { render, staticRenderFns } from "./PedidoProcessoIntroducao.vue?vue&type=template&id=8fa9c1a2"
import script from "./PedidoProcessoIntroducao.vue?vue&type=script&lang=js"
export * from "./PedidoProcessoIntroducao.vue?vue&type=script&lang=js"
import style0 from "./PedidoProcessoIntroducao.vue?vue&type=style&index=0&id=8fa9c1a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
